module.exports = __webpack_public_path__ + "static/media/dairyFree.91769a79.jpg";